import { Breadcrumbs } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../../Utils/_helpers";
import { Tracker } from "../../../../util/analytics";
import { getUser } from "../../../../util/helpers";
import { selectedQueueView } from "../../state/actions/queueMonitorActions";
import { setLiveInteractionPageTabIndex } from "../../state/slices/liveInteractionsSlice";
import QueueViewSelectionPopper from "../QueueMonitoring/QueueDetails/QueueViewSelectionPopper";

function a11yProps(index) {
  return {
    id: `live-interactions-tab-${index}`,
    "aria-controls": `live-interactions-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    justifyContent: "center",
    display: "flex",
    [theme.breakpoints.down("md")]: {
      minHeight: "54px",
      paddingLeft: theme.spacing(4),
    },
  },
  tabRoot: {
    margin: "0 33px 0 0",
    padding: " 1px 7px 2px 1px",
    borderRadius: "4px",
    color: "#2c3687",
    minHeight: "31px",
    alignItems: "center",
    fontSize: "13px",
    textTransform: "capitalize",
    "&.Mui-selected": {
      backgroundColor: "#f3f6f9",
      color: "#2c3687",
      fontWeight: theme.typography.fontWeightMedium,
      outline: 0,
    },
    [theme.breakpoints.down("md")]: {
      "&.Mui-selected": {
        backgroundColor: "transparent",
      },
    },
  },
  indicator: {
    backgroundColor: "transparent",
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(3),
      backgroundColor: "#443092",
    },
  },
  tabs: {
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      alignItems: "normal",
      paddingTop: theme.spacing(1.6),
    },
  },
  breadCrumbContainer: {
    display: "flex",
    alignItems: "center",
    marginLeft: "-20px",
  },
}));

const LiveInteractionsSubHeader = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const { extra_data } = useSelector(({ auth }) => ({
    extra_data: auth.extra_data,
  }));

  const selectedTab = useSelector(
    (state) => state.liveInteractionsSlice.activeTab
  );

  const selectedQueueCallHandling = useSelector(
    (state) => state.queueMonitor.selectedQueueDetails
  );

  useEffect(() => {
    if (location.pathname.includes("/queue-monitor")) {
      dispatch(setLiveInteractionPageTabIndex(1));
    } else {
      dispatch(setLiveInteractionPageTabIndex(0));
    }
  }, []);

  const [openQueuePopper, setopenQueuePopper] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleChange = (event, newValue) => {
    Tracker.event(
      newValue === 0
        ? "Call Monitoring"
        : Object.keys(selectedQueueCallHandling).length > 0
        ? "Queue Monitoring Detail"
        : "Queue Monitoring",
      "Click",
      newValue === 0 ? "Call Monitoring Tab" : "Queue Monitoring Tab",
      newValue === 0 ? "Call Monitoring Tab" : "Queue Monitoring Tab",
      getUser()
    );
    if (newValue === 0) {
      history.push("/live-interactions/call-monitor");
    } else {
      history.push("/live-interactions/queue-monitor");
    }
    dispatch(setLiveInteractionPageTabIndex(newValue));
    dispatch(selectedQueueView({}));
  };

  const openPopover = (event) => {
    setAnchorEl(event.currentTarget);
    setopenQueuePopper(true);
  };

  const closePopover = () => {
    setopenQueuePopper(false);
    setAnchorEl(null);
  };

  return (
    <div className="d-flex flex-grow-1">
      <div className={`${classes.root}`}>
        <Tabs
          value={selectedTab}
          onChange={handleChange}
          TabIndicatorProps={{ className: classes.indicator }}
          aria-label="live-interactions"
          className={`${classes.tabs}`}
        >
          {extra_data && extra_data.is_call_monitor === 1 && (
            <Tab
              className={classes.tabRoot}
              label="Call Monitor"
              {...a11yProps(0)}
            />
          )}
          {extra_data && extra_data.is_queue_monitor === 1 && (
            <Tab
              className={classes.tabRoot}
              label="Queue Monitor"
              {...a11yProps(1)}
            />
          )}
        </Tabs>
      </div>

      {Object.keys(selectedQueueCallHandling).length && selectedTab > 0 ? (
        <div className={`${classes.breadCrumbContainer} d-none d-lg-flex`}>
          <Breadcrumbs separator="">
            <img
              alt="logo"
              src={toAbsoluteUrl("/media/sr/icons/breadcrumb-arrow.svg")}
            />
            <div onClick={openPopover} style={{ cursor: "pointer" }}>
              <span style={{ color: "#6c7293", fontSize: "13px" }}>
                {selectedQueueCallHandling["queue"]["queue_name"]}
              </span>
              <span style={{ paddingLeft: "8px" }}>
                <img
                  alt="logo"
                  src={toAbsoluteUrl("/media/sr/icons/select-arrow.svg")}
                />
              </span>
            </div>
            <QueueViewSelectionPopper
              anchorEl={anchorEl}
              open={openQueuePopper}
              handleClose={closePopover}
            />
          </Breadcrumbs>
        </div>
      ) : null}
    </div>
  );
};

export default LiveInteractionsSubHeader;
